import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { LayoutState } from './layout-state';

@Injectable({
  providedIn: 'root'
})
export class LayoutService {

  private layoutSubject = new Subject<any>();
  private layoutState: LayoutState = {
    isFullWidth: false,
    isExtendedFooter: false
  };

  constructor() { }

  public get state(): LayoutState {
    return this.layoutState;
  }

  public get layoutStates(): Observable<LayoutState> {
    return this.layoutSubject.asObservable();
  }

  public defaultWidth(): void {
    this.layoutState = { ...this.layoutState, isFullWidth: false };
    this.layoutSubject.next(this.layoutState);
  }
  public fullWidth(): void {
    this.layoutState = { ...this.layoutState, isFullWidth: true };
    this.layoutSubject.next(this.layoutState);
  }
  public setExtendedFooter(isExtendedFooter: boolean) {
    this.layoutState = { ...this.layoutState, isExtendedFooter };
    this.layoutSubject.next(this.layoutState);
  }
}
